import { create } from "zustand";

import { TJobTypeId } from "@type/api/corporation/types";

type TJobListingTypeIdStore = {
  basicWageJob?: TJobTypeId[];
  loadingGetBasicWageJob: boolean;
  employmentSecurityJob?: TJobTypeId[];
  loadingEmploymentSecurityJob: boolean;
  onSetBasicWageJob: (basicWageJob: TJobTypeId[]) => void;
  onSetLoadingGetBasicWageJob: (loadingGetBasicWageJob: boolean) => void;
  onSetEmploymentSecurityJob: (employmentSecurityJob: TJobTypeId[]) => void;
  onSetLoadingEmploymentSecurityJob: (
    loadingEmploymentSecurityJob: boolean
  ) => void;
};

export const useJobListingTypeIdStore = create<TJobListingTypeIdStore>(
  (set) => ({
    basicWageJob: undefined,
    loadingGetBasicWageJob: false,
    employmentSecurityJob: undefined,
    loadingEmploymentSecurityJob: false,
    onSetBasicWageJob: (basicWageJob) => {
      set((state) => {
        return {
          ...state,
          basicWageJob: [
            ...(state?.basicWageJob ? state.basicWageJob : []),
            ...basicWageJob,
          ],
        };
      });

      set({ basicWageJob });
    },
    onSetLoadingGetBasicWageJob: (loadingGetBasicWageJob) => {
      set({ loadingGetBasicWageJob });
    },
    onSetEmploymentSecurityJob: (employmentSecurityJob) => {
      set((state) => {
        return {
          ...state,
          employmentSecurityJob: [
            ...(state?.employmentSecurityJob
              ? state.employmentSecurityJob
              : []),
            ...employmentSecurityJob,
          ],
        };
      });

      set({ employmentSecurityJob });
    },
    onSetLoadingEmploymentSecurityJob: (loadingEmploymentSecurityJob) => {
      set({ loadingEmploymentSecurityJob });
    },
  })
);
